"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AddressInputBase = void 0;
var _react = _interopRequireWildcard(require("react"));
var _mui = require("tss-react/mui");
var _googleMapsReact = require("google-maps-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _List = _interopRequireDefault(require("@mui/material/List"));
var _ListItem = _interopRequireDefault(require("@mui/material/ListItem"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _Input = _interopRequireDefault(require("../Input"));
var _excluded = ["google", "loaded", "value", "handleChange"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// TODO jss-to-tss-react codemod: Unable to handle style definition reliably.
// ArrowFunctionExpression in CSS prop.
var useStyles = (0, _mui.makeStyles)()(function (theme) {
  return {
    input: {
      marginBottom: theme.spacing(2),
      fontSize: 'inherit'
    },
    predictions: {
      transition: theme.transitions.create('height'),
      height: function height(_ref) {
        var predictions = _ref.predictions;
        return predictions && predictions.length * 45;
      }
    },
    predictionsWithItems: {
      borderTop: "1px solid ".concat(theme.palette.divider),
      borderRight: "1px solid ".concat(theme.palette.divider),
      borderLeft: "1px solid ".concat(theme.palette.divider),
      borderRadius: theme.shape.borderRadius,
      marginBottom: theme.spacing(2)
    },
    predictionText: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    mapContainer: {
      borderRadius: theme.shape.borderRadius,
      height: 200,
      position: 'relative',
      overflow: 'hidden'
    }
  };
});
var MapLoader = function MapLoader() {
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.mapContainer
  }, /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
    loading: true
  }));
};
var AddressInputBase = function AddressInputBase(_ref2) {
  var google = _ref2.google,
    loaded = _ref2.loaded,
    _ref2$value = _ref2.value,
    coordinates = _ref2$value.coordinates,
    locationAddress = _ref2$value.address,
    handleChange = _ref2.handleChange,
    inputProps = _objectWithoutProperties(_ref2, _excluded);
  var _useState = (0, _react.useState)(locationAddress),
    _useState2 = _slicedToArray(_useState, 2),
    address = _useState2[0],
    setAddress = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    predictions = _useState4[0],
    setPredictions = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedPlaceId = _useState6[0],
    setSelectedPlaceId = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    sessionToken = _useState8[0],
    setSessionToken = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = _slicedToArray(_useState9, 2),
    mapCenter = _useState10[0],
    setMapCenter = _useState10[1];
  var timerRef = (0, _react.useRef)();
  var _useStyles2 = useStyles({
      predictions: predictions
    }),
    classes = _useStyles2.classes,
    cx = _useStyles2.cx;
  var getPredictions = function getPredictions(value) {
    return function () {
      var autocompleteService = new google.maps.places.AutocompleteService();
      handleChange(undefined);
      setSelectedPlaceId(null);
      autocompleteService.getPlacePredictions({
        input: value,
        sessionToken: sessionToken,
        location: new google.maps.LatLng(mapCenter),
        radius: 100000
      }, function (fetchedPredictions) {
        return setPredictions(fetchedPredictions || []);
      });
    };
  };
  var handleAddressChange = function handleAddressChange(value) {
    setAddress(value);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(getPredictions(value), 750);
  };
  var setPlace = function setPlace(place) {
    setSessionToken(new google.maps.places.AutocompleteSessionToken());
    var country;
    var city;
    for (var i = 0; i < place.address_components.length; i += 1) {
      var _place$address_compon = place.address_components[i],
        name = _place$address_compon.long_name,
        types = _place$address_compon.types;
      if (types.includes('country')) country = name;
      if (types.includes('locality')) city = name;
      if (country && city) break;
    }
    handleChange({
      coordinates: {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      },
      address: address,
      country: country,
      city: city
    });
  };
  var selectPlace = function selectPlace(placeId, description) {
    return function () {
      setSelectedPlaceId(placeId);
      setAddress(description);
      setPredictions([]);
    };
  };
  (0, _react.useEffect)(function () {
    if (google) setSessionToken(new google.maps.places.AutocompleteSessionToken());
  }, [google]);
  (0, _react.useEffect)(function () {
    if (coordinates.lat && coordinates.lng || !navigator.geolocation) {
      setMapCenter(coordinates);
      return;
    }
    navigator.geolocation.getCurrentPosition(function (position) {
      return setMapCenter({
        lat: position.coords.latitude,
        lng: position.coords.longitude
      });
    });
  }, [coordinates]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({}, inputProps, {
    className: classes.input,
    value: address,
    handleChange: handleAddressChange
  })), /*#__PURE__*/_react["default"].createElement(_List["default"], {
    className: cx(classes.predictions, !!predictions.length && classes.predictionsWithItems),
    disablePadding: true
  }, !!predictions.length && predictions.map(function (_ref3) {
    var placeId = _ref3.place_id,
      description = _ref3.description;
    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      button: true,
      divider: true,
      key: placeId,
      onClick: selectPlace(placeId, description)
    }, /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      className: classes.predictionText
    }, description));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.mapContainer
  }, /*#__PURE__*/_react["default"].createElement(_googleMapsReact.Map, {
    google: google,
    center: mapCenter,
    zoom: 16,
    draggable: false,
    scrollwheel: false,
    onReady: getPredictions,
    disableDefaultUI: true
  }, /*#__PURE__*/_react["default"].createElement(SelectedPlace, {
    id: selectedPlaceId,
    setPlace: setPlace,
    sessionToken: sessionToken
  }), coordinates.lat && coordinates.lng && /*#__PURE__*/_react["default"].createElement(_googleMapsReact.Marker, {
    position: coordinates
  }))));
};
exports.AddressInputBase = AddressInputBase;
var SelectedPlace = function SelectedPlace(_ref4) {
  var google = _ref4.google,
    map = _ref4.map,
    id = _ref4.id,
    setPlace = _ref4.setPlace,
    sessionToken = _ref4.sessionToken;
  (0, _react.useEffect)(function () {
    if (!map || !id) return;
    var request = {
      placeId: id,
      fields: ['name', 'geometry', 'address_component'],
      sessionToken: sessionToken
    };
    var placesService = new google.maps.places.PlacesService(map);
    placesService.getDetails(request, setPlace);
  }, [map, id]);
  return null;
};
AddressInputBase.propTypes = {
  value: _propTypes["default"].shape({
    coordinates: _propTypes["default"].shape({
      lat: _propTypes["default"].number,
      lng: _propTypes["default"].number
    }),
    address: _propTypes["default"].string,
    country: _propTypes["default"].string,
    city: _propTypes["default"].string
  }),
  google: _propTypes["default"].shape({
    maps: _propTypes["default"].shape({
      LatLng: _propTypes["default"].func,
      places: _propTypes["default"].shape({
        AutocompleteSessionToken: _propTypes["default"].func,
        AutocompleteService: _propTypes["default"].func
      })
    })
  }).isRequired,
  loaded: _propTypes["default"].bool.isRequired,
  handleChange: _propTypes["default"].func.isRequired
};
AddressInputBase.defaultProps = {
  value: {
    coordinates: {
      lat: undefined,
      lng: undefined
    },
    address: undefined,
    country: undefined,
    city: undefined
  }
};
SelectedPlace.propTypes = {
  google: _propTypes["default"].shape({
    maps: _propTypes["default"].shape({
      LatLng: _propTypes["default"].func,
      places: _propTypes["default"].shape({
        AutocompleteSessionToken: _propTypes["default"].func,
        AutocompleteService: _propTypes["default"].func,
        PlacesService: _propTypes["default"].func
      })
    })
  }).isRequired,
  map: _propTypes["default"].string.isRequired,
  // TODO: check how this is used
  id: _propTypes["default"].string.isRequired,
  setPlace: _propTypes["default"].func.isRequired,
  sessionToken: _propTypes["default"].string.isRequired
};
var _default = (0, _googleMapsReact.GoogleApiWrapper)({
  apiKey: 'AIzaSyCJeSmCwDbQ5HVKW0yB4hmJ6WHKqXlf6kw',
  libraries: ['places'],
  LoadingContainer: MapLoader
})(AddressInputBase);
exports["default"] = _default;